<div
    class="slide-element-container"
    [class.has-dark]="dark"
    [class.nativescroll]="nativeScroll"
    [class.min-scrollcustom-x]="!hideScroll && customScroll"
>
    <div
        class="is-flex"
        [class.min-scrollcustom-x]="hideScroll && customScroll"
        [class.inner-nativescroll]="!(hideScroll && customScroll)"
        (scroll)="onScroll($event)"
        #divContainer
    >
        <ng-content></ng-content>
    </div>
</div>
